module.exports = "/assets/cbb90f1875fae9a4f26eea4c784de16e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/P5.png
// module id = 1704
// module chunks = 0